export const idEstadosOrden = {
    pendiente: 1,
    facturado: 2,
    solicitarAnulacion: 3,
    entregado: 4,
    anulado: 5
}

export const isEstadoVentaAprobado = (estadoVenta) =>
    typeof estadoVenta === "string" &&
    estadoVenta.trim().toLowerCase().startsWith("aproba");

/** Normaliza id de estado (la API a veces envía número o string). */
export const normalizeIdEstadoOrden = (idEstado) => {
    const n = Number(idEstado);
    return Number.isFinite(n) ? n : null;
};

export const getLabelEstadoById = (idEstado) => {
    const id = normalizeIdEstadoOrden(idEstado);
    const { pendiente, facturado, solicitarAnulacion, entregado, anulado } = idEstadosOrden;
    switch (id) {
        case pendiente:
            return { label: "PENDIENTE", color: "grey" };
        case facturado:
            return { label: "FACTURADO", color: "success" };
        case solicitarAnulacion:
            return { label: "SOL. ANULACION", color: "grey" };
        case entregado:
            return { label: "ENTREGADO", color: "info" };
        case anulado:
            return { label: "ANULADO", color: "danger" };
        default:
            return { label: "", color: "" };
    }
}

export const filtroEstados = [
    { value: 6, label: "TODOS" },
    { value: 1, label: "PENDIENTE" },
    { value: 2, label: "FACTURADO" },
    { value: 3, label: "SOL. ANULACION" },
    { value: 4, label: "ENTREGADO" },
    { value: 5, label: "ANULADO" }
]

export const filtroEstadosProveedor = [
    { value: "", label: "Todos" },
    { value: true, label: "Descargados" },
    { value: false, label: "No Descargados" },
]

export const getLogoPlataformaById = (plataformaCodigo) => {
    switch (plataformaCodigo) {
        case 0:
            return "/img/icono-megatone.png"
        case 1:
            return "/img/icono-mega-Market.png"
        case 2:
            return "/img/icono-megatone-express.png"
        default:
            return ""
    }
}

export const hasMetodoPagoPermitido = (cupones, metodosPermitidos) => {
    if (!cupones || cupones.length === 0) return false;

    const metodosUpper = metodosPermitidos.map(m => m.toUpperCase());

    return cupones.some((cupon) => {
        const metodo = (cupon?.metodoPago ?? cupon?.MetodoPago ?? "").toString().trim();
        return metodosUpper.includes(metodo.toUpperCase());
    });
};
  
  
  
